document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.product__information-popup')) {
        const popupOpener = document.querySelector('.product__information-popup');

        popupOpener.addEventListener('click', function () {
            console.log('click')
            setTimeout(function () {
                sizeguideListener();
            }, 200)
        })

        function sizeguideListener() {
            const metricSwitcher = document.querySelectorAll('.size-guide__metric-switcher input[type="radio"][name="metric-system"]');
            const bodyContainer = document.querySelectorAll('.size-guide__body');

            metricSwitcher.forEach(function (radioEl) {
                radioEl.addEventListener('change', function (event) {

                    bodyContainer.forEach(function (bodyEl) {
                        bodyEl.dataset.metric = event.target.value;
                    })
                })
            })
        }
    }
})

window.addEventListener("load", function () {
    if (document.querySelector('.template-product')) {
        const videoContainers = document.querySelectorAll('.product__media-item[data-media-type="video"]');

        videoContainers.forEach(function (item) {
            if (!item.querySelector('.plyr__video-wrapper')) {
                let player = new Shopify.Plyr(item.querySelector('video'));
            }
        });
    }
})